import React from "react";
import { TextField } from "@material-ui/core";

const Select = ({
  label,
  name,
  handleChange,
  values,
  options,
  required = false,
}) => {
  return (
    <TextField
      style={{ marginTop: "16px" }}
      fullWidth
      label={label}
      name={name}
      onChange={handleChange}
      required={required}
      select
      SelectProps={{ native: true }}
      value={values[name]}
      variant="outlined"
    >
      {options.map((option) => (
        <option key={option.key} value={option.value}>
          {option.label}
        </option>
      ))}
    </TextField>
  );
};

export default Select;
